export const Close = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_15000_6258)">
      <path
        d="M12.5 10.586L17.45 5.63599L18.864 7.04999L13.914 12L18.864 16.95L17.45 18.364L12.5 13.414L7.54999 18.364L6.13599 16.95L11.086 12L6.13599 7.04999L7.54999 5.63599L12.5 10.586Z"
        fill="#88819F"
      />
    </g>
    <defs>
      <clipPath id="clip0_15000_6258">
        <rect width="24" height="24" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);
